export default {
  "activityBonusConfig.title": "活动奖金配置",
  "activityBonusConfig.column.no": "#序号",
  "activityBonusConfig.column.eventId": "事件ID",
  "activityBonusConfig.column.bonusAmount": "奖金金额",
  "activityBonusConfig.column.wager": "投注额",
  "activityBonusConfig.column.enable": "启用",
  "activityBonusConfig.column.createTime": "创建时间",
  "activityBonusConfig.column.action": "操作",
  "activityBonusConfig.action.edit": "编辑",
  "activityBonusConfig.action.enable": "启用",
  "activityBonusConfig.action.disable": "禁用",
  "activityBonusConfig.form.eventType": "事件类型",
  "activityBonusConfig.form.bonusAmount": "奖金金额",
  "activityBonusConfig.form.wager": "投注额",
  "activityBonusConfig.search.enable": "启用",
  "activityBonusConfig.search.disable": "禁用",
  "activityBonusConfig.confirm.enable.title": "启用活动奖金: {eventId}",
  "activityBonusConfig.confirm.disable.title": "禁用活动奖金: {eventId}",
  "activityBonusConfig.confirm.enable.content": "确定要启用此活动奖金吗？",
  "activityBonusConfig.confirm.disable.content": "确定要禁用此活动奖金吗？",
  "activityBonusConfig.confirm.ok": "确认",
  "activityBonusConfig.confirm.cancel": "取消",
  "activityBonusConfig.add": "新增",
  "activityBonusConfig.edit": "编辑",
};